import Form from "./Form";
import Field from "./Field";
import Link from "./Link";

class FormBuilder {

    get(formData) {
        let submit = new Link(formData.submit.url, formData.submit.label, formData.submit.color, formData.submit.direction);
        let form = new Form(submit);

        form.fields = formData.fields.map(field => new Field(
            field.name,
            field.type,
            field.label,
            field.required !== undefined ? field.required : false
        ));

        return form;
    }
}

export default FormBuilder;